export enum TextUmstellungsfaehigkeit {
  AUTOMATISCH = "Umstellungsfähig",
  BEDINGT = "Bedingt umstellungsfähig",
  NICHT = "Per Ersatzantrag umstellbar",
}
